import { render, staticRenderFns } from "./documentAuthApply.vue?vue&type=template&id=33790922&scoped=true&"
import script from "./documentAuthApply.vue?vue&type=script&lang=ts&"
export * from "./documentAuthApply.vue?vue&type=script&lang=ts&"
import style0 from "./documentAuthApply.vue?vue&type=style&index=0&id=33790922&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33790922",
  null
  
)

export default component.exports